module.exports = __webpack_public_path__ + "img/contacto.a262c262.png";